/**
 *
 */
'use strict';
var layer = $.Deferred();
require.ensure('layer', function() {
    layer.resolve(require('layer'));
});

// 执行校验规则
module.exports = function execute(context) {
    var ret_deferred = $.Deferred();
    layer.done(function(layer) {
        var items = $('[validate]', context).not('[disabled]');
        if (items && items.length) {
            var len = items.length;
            val.apply(ret_deferred, [0, items, layer]);
        } else {
            ret_deferred.resolve(); // 没有需要校验的，就直接通过
        }
    });
    return ret_deferred.promise();
}

function val(index, items, layer) {
    var ret_deferred = this,
        len = items.length;
    if (index == len) {
        ret_deferred.resolve(); //
    } else {
        var deferred = $.Deferred(),
            $this = $(items[index]),
            validate = new Function('return ' + $this.attr('validate'))(),
            option = new Function('return ' + $this.data('option'))(),
            pending_deferreds = [];
        $.each(validate, function(key, value) {
            if (value === true || typeof value === 'object') {
                var result = val_funcs[key].call($this, value, option, layer);
                if (result === false) {
                    deferred.reject($this, value, option);
                    return false; // break
                } else if (result && $.isFunction(result.promise)) {
                    pending_deferreds.push(result);
                } else {
                    // do nothing. continue;
                }
            }
        });

        var state = deferred.state();
        if (state === 'pending') {
            if (pending_deferreds.length) {
                $.when.apply(null, pending_deferreds).then(function() {
                    val.apply(ret_deferred, [++index, items, layer]);
                }, function() {
                    ret_deferred.reject($this);
                })
            } else {
                val.apply(ret_deferred, [++index, items, layer]);
            }
        } else if (state == 'resovled') {
            val.apply(ret_deferred, [++index, items, layer]);
        } else {
            ret_deferred.reject($this);
        }
    }
}

// 校验函数=====================
var val_funcs = {
    require: function(param, option, layer) {
        var $this = $(this),
            val = $.trim($this.val() || $this.attr('value')),
            ph = $this.attr('placeholder');
        if (!val) {
            layer.tips(param.tips || ph || '不能为空', this, { validating: true});
            return false;
        }
    },
    unique: function(param, option, layer) {
        var $this = $(this),
            name = param.name,
            url = param.url,
            old = param.old,
            value = $.trim($this.val()),
            data = {},
            deferred = $.Deferred();
        // 如果值为空，则不进行检查
        if (!value) {
            return;
        }
        // 如果新值与旧值相等，则不必进行唯一性检查
        if (old == value) {
            return;
        }
        data.name = name;
        data.value = value;
        $.ajax({
            url: url,
            type: 'post',
            data: data,
            success: function(tip) {
                if (tip.result == 'success') {
                    deferred.resolve()
                } else {
                    layer.tips(param.tips || '该值已存在，不能使用', { validating: true })
                    deferred.reject()
                }
            },
            error: deferred.reject
        })
        return deferred;
    },
    len: function(param, option, layer) {
        var $this = $(this),
            max = +param.max,
            min = +param.min || 1,
            val = $.trim($this.val()),
            len = val.length || 0;
        // 如果值为空，则不进行检查
        if (!val) {
            return;
        }
        if ((max && max < len) || (min && min > len)) {
            layer.tips(param.tips || new Function("min", "max", 'return ' + ('"长度必须在"+ min +", " +max+ "之间"'))(min, max), this, { validating: true });
            return false;
        }
    },
    range: function(param, option, layer) {
        var $this = $(this),
            val = +$this.val(),
            max = +param.max || 99999999,
            min = +param.min || 0;
        // 如果值为空，则不进行检查
        if (!val && val !== 0) {
            return;
        }
        if ((max && max < val) || (min > val)) {
            layer.tips(param.tips || new Function("min", "max", 'return ' + ('"数值必须在"+ min +", " +max+ "之间"'))(min, max), this, { validating: true });
            return false;
        }
    },
    reg: function(param, option, layer) {
        var $this = $(this),
            reg = new RegExp(param.exp),
            url = param.url,
            value = $.trim($this.val());
        // 如果值为空，则不进行检查
        if (!value) {
            return;
        }
        if (!reg.test(value)) {
            layer.tips(param.tips || '格式不正确', this, { validating: true });
            return false;
        }
    },
    tel: function(param, option, layer) {
        var $this = $(this),
            reg = /^0\d{2,3}-?\d{7,8}$/,
            reg400 = /^400\d{7}$/,
            url = param.url,
            value = $.trim($this.val());
        if (!value) {
            return;
        }
        if (!(reg.test(value) || reg400.test(value) || (val_funcs.phone.apply(this, arguments) !== false))) {
            layer.tips('请输入正确格式电话号码', this, { validating: true});
            return false;
        }
    },
    num: function(param, option, layer) {
        var $this = $(this),
            reg = param.int ? /^\d+$/ : /^\d+(\.\d{0,4})?$/,
            url = param.url,
            value = $.trim($this.val());
        if (!value) {
            return;
        }
        if (!reg.test(value)) {
            layer.tips('请输入数字', this, { validating: true });
            return false;
        }
    },
    phone: function(param, option, layer) {
        var $this = $(this),
            reg = /^(13[0-9]|14[0-9]|15[0-9]|17[0-9]|18[0-9])\d{8}$/g,
            value = $.trim($this.val());
        if (!value) {
            return;
        }
        if (!reg.test(value)) {
            layer.tips('请输入正确格式的手机号码', this);
            return false;
        }
    },
    email: function(param, option, layer) {
        var $this = $(this),
            reg = /^(\w-*\.*)+@(\w-?)+(\.\w{2,})+$/,
            value = $.trim($this.val());
        if (!value) {
            return;
        }
        if (!reg.test(value)) {
            layer.tips(' 请输入正确格式的邮箱 ', this, { validating: true });
            return false;
        }
    },
    checked: function(param, option, layer) {
        var $this = $(this);
        if (!$this.is(' : checked ')) {
            layer.tips(' 此项必须勾选 ', this)
            return false;
        }
    },
    eq: function(param, option, layer) {
        var $this = $(this),
            target = $(param.selector),
            s_val = $.trim($this.val()),
            t_val = $.trim(target.val());
        if (s_val !== t_val) {
            layer.tips(param.msg || ' 二者不一致', this, { validating: true })
            return false;
        }
    }
}


/*****************
 ** WEBPACK FOOTER
 ** ./lib/form.validate.js
 ** module id = 107
 ** module chunks = 2 3 5 6 7 8 9 11 12 13 14 15 16 17 18
 **/